import { useMemo } from "react"
import { map, size, capitalize } from "lodash"

export const useAvailableMetrics = (modelMetrics, specificMetrics, categoryTotals = false) => useMemo(() => {
  return [
    specificMetrics,
    // Performance allows for category total metrics. eg. 'Style Total'
    ...map(modelMetrics, (metric) => {
      const options = size(metric?.options) > 1 && categoryTotals ? [{
        id: metric.id,
        label: `${capitalize(metric.id)} Total`,
        category: metric.id,
      },
      ...metric.options] : metric?.options

      return ({
        ...metric,
        options,
      })
    }),
  ]
}, [specificMetrics, modelMetrics, categoryTotals])
